module.exports = __webpack_public_path__ + "media/images/brand/original/MARQUESBRANDINGCO LOGO X-d2edc992712486df558fd204f1fea6af.png";